/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetDeviceIntegrationCoverageSecurity = {
  apikeyHeaderGramKey?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type GetDeviceIntegrationCoverageRequest = {
  /**
   * Optionally scope coverage to one provider (e.g. jamf).
   */
  provider?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type GetDeviceIntegrationCoverageSecurity$Outbound = {
  "apikey_header_Gram-Key"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const GetDeviceIntegrationCoverageSecurity$outboundSchema: z.ZodMiniType<
  GetDeviceIntegrationCoverageSecurity$Outbound,
  GetDeviceIntegrationCoverageSecurity
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getDeviceIntegrationCoverageSecurityToJSON(
  getDeviceIntegrationCoverageSecurity: GetDeviceIntegrationCoverageSecurity,
): string {
  return JSON.stringify(
    GetDeviceIntegrationCoverageSecurity$outboundSchema.parse(
      getDeviceIntegrationCoverageSecurity,
    ),
  );
}

/** @internal */
export type GetDeviceIntegrationCoverageRequest$Outbound = {
  provider?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const GetDeviceIntegrationCoverageRequest$outboundSchema: z.ZodMiniType<
  GetDeviceIntegrationCoverageRequest$Outbound,
  GetDeviceIntegrationCoverageRequest
> = z.pipe(
  z.object({
    provider: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
    });
  }),
);

export function getDeviceIntegrationCoverageRequestToJSON(
  getDeviceIntegrationCoverageRequest: GetDeviceIntegrationCoverageRequest,
): string {
  return JSON.stringify(
    GetDeviceIntegrationCoverageRequest$outboundSchema.parse(
      getDeviceIntegrationCoverageRequest,
    ),
  );
}
